import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"



const AdminSideBar = ({ View }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return (
        windowWidth < 992 ? (View ? (<div className="mh-100vh" >
            <div className="d-flex flex-column">
                <Link to="/admin/allorders" >
                    <div className="fw-bold mt-3 border-bottom p-3 mx-auto text-white">
                        Manage Orders
                    </div>
                </Link>

                <Link to="/admin/allproducts" >
                    <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                        Manage Products
                    </div>
                </Link>

                <Link to="/admin/allbrands" >
                    <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                        Manage Brands
                    </div>
                </Link>

                <Link to="/admin/allcategory" >
                    <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                        Manage Categories
                    </div>
                </Link>

                {/* <Link to="/admin/allsubcategory" >
    <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
        Manage Sub Categories
    </div>
</Link> */}

                <Link to="/admin/allcoupons" >
                    <div className="fw-bold my-1 p-3 mx-auto text-white">
                        Manage Coupons
                    </div>
                </Link>

            </div>
        </div>) : null) : (
            <div className="mh-100vh" >
                <div className="d-flex flex-column">
                    <Link to="/admin/allorders" >
                        <div className="fw-bold mt-3 border-bottom p-3 mx-auto text-white">
                            Manage Orders
                        </div>
                    </Link>

                    <Link to="/admin/allproducts" >
                        <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                            Manage Products
                        </div>
                    </Link>

                    <Link to="/admin/allbrands" >
                        <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                            Manage Brands
                        </div>
                    </Link>

                    <Link to="/admin/allcategory" >
                        <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
                            Manage Categories
                        </div>
                    </Link>

                    {/* <Link to="/admin/allsubcategory" >
        <div className="fw-bold my-1 border-bottom p-3 mx-auto text-white">
            Manage Sub Categories
        </div>
    </Link> */}

                    <Link to="/admin/allcoupons" >
                        <div className="fw-bold my-1 p-3 mx-auto text-white">
                            Manage Coupons
                        </div>
                    </Link>

                </div>
            </div>)

    )
}

export default AdminSideBar
